export const PERMISSIONS = {
  NAV_BAR: {
    CAN_VIEW_DEPLOYMENT_NOTES: 'core.can_view_deployment_notes',
    CAN_VIEW_GENERATE_CODE: 'core.can_view_generate_code'
  },
  PATIENT_MANAGEMENT: {
    CAN_ADD_PATIENT: 'core.can_add_patient',
    CAN_ADD_CYCLE_TO_PATIENT: 'core.can_add_cycle_to_patient',
    CAN_CANCEL_CYCLE_TO_PATIENT: 'core.can_cancel_cycle_to_patient',
    CAN_EDIT_COUNTRY: 'core.can_edit_country',
    CAN_VIEW_OPERATION: 'core.can_view_operation'
  },
  COHORTS: {
    CAN_CHANGE_COHORT_STATUS: 'core.can_change_cohort_status',
    CAN_ADD_ACTIVITIES: 'core.can_add_activities',
    CAN_CHECK_REVERSE_STATE: 'core.can_check_reverse_state'
  },
  SCHEDULE: {
    CAN_ADD_SCHEDULE: 'core.can_add_schedule',
    CAN_EDIT_SCHEDULE: 'core.can_edit_schedule',
    CAN_VIEW_CONFIRM_PATIENT: 'core.can_view_confirm_patient'
  },
  CONTROL_TOWER: {
    CAN_CLIC_BADGE_CONTROL_TOWER: 'core.can_clic_badge_control_tower'
  },
  TEMPLATES: {
    SIGIRES: 'massive_load.can_view_template_SIGIRES',
    BACK_ONCOLOGY: 'massive_load.can_view_template_BACK_ONCOLOGY',
    PSA: 'massive_load.can_view_template_PSA',
    PATHOLOGY: 'massive_load.can_view_template_PATHOLOGY',
    PREACTIVE_PATIENTS: 'massive_load.can_view_template_PREACTIVE_PATIENTS',
    ACTIVE_PATIENTS: 'massive_load.can_view_template_ACTIVE_PATIENTS',
    GOOGLE_DRIVE: 'massive_load.can_view_template_GOOGLE_DRIVE',
    AUTHORIZATIONLESS: 'massive_load.can_view_template_AUTHORIZATIONLESS',
    SERVICE_STATUS_UPDATE: 'massive_load.can_view_template_SERVICE_STATUS',
    PRESUMPTIVE_COLON: 'massive_load.can_view_template_DIAGNOSTIC_COLON',
    PRESUMPTIVE_CERVIX: 'massive_load.can_view_template_DIAGNOSTIC_CERVIX',
    PRESUMPTIVE_BREAST: 'massive_load.can_view_template_DIAGNOSTIC_BREAST',
    PRESUMPTIVE_PROSTATE: 'massive_load.can_view_template_DIAGNOSTIC_PROSTATE',
    SERVICE_STATUS_AUTHORIZATION:
      'massive_load.can_view_template_SERVICE_STATUS_AUTHORIZATION',
    CANCER_MAMMOGRAPHY: 'massive_load.can_view_template_MAMMOGRAPHY',
    SUPPORTS_LOAD:
      'massive_load.can_view_template_AUTHORIZATION_AND_SUPPORT_ID',
    PGP_LOAD: 'massive_load.can_view_template_BACK_ONCOLOGY_WITH_APPOINTMENT',
    PATIENTS_VALIDATIONS_ACTIVE:
      'massive_load.can_view_template_DATA_ACTIVE_PATIENTS',
    VALIDATION_CUP_DATA: 'massive_load.can_view_template_VALIDATION_CUP_DATA',
    AUTH_VS_MEDICAL_ORDER:
      'massive_load.can_view_AUTHORIZATION_NUMBER_BY_MEDICAL_ORDER_NUMBER'
  },
  TREATMENTS: {
    ADD_PATIENT_DIAGNOSIS: 'treatments.add_patientdiagnosis'
  },
  USERS: {
    CAN_CREATE_USER: 'core.can_create_user',
    CAN_MANAGE_USER: 'core.can_manage_user',
    CAN_VIEW_USER_PROFILE: 'core.can_view_user_profile'
  },
  REPORTS: {
    CAN_VIEW_REPORTS_DATATABLE: 'core.can_view_reports_datatable',
    CAN_VIEW_REPORTS_BTN: 'core.can_view_reports_btn',
    CAN_VIEW_ALL_REPORTS: 'core.can_view_all_reports',
    CAN_VIEW_TRANSACTIONAL_REPORTS: 'core.can_view_transactional_reports',
    CAN_VIEW_POPULATION_REPORTS: 'core.can_view_population_reports'
  },
  WORK_UNIT: {
    CAN_VIEW_INDICATORS_BTN_WORK_UNIT: 'core.can_view_indicators_btn_work_unit',
    CAN_VIEW_SURVEY_BTN_WORK_UNIT: 'core.can_view_survey_btn_work_unit',
    CAN_VIEW_PATIENT_BTN_WORK_UNIT: 'core.can_view_patient_btn_work_unit',
    CAN_VIEW_SURVEY_TABLE_BTN_WORK_UNIT: 'core.can_view_survey_table_btn_work_unit',
    CAN_VIEW_SWITCH_SURVEY_MODULE_V2: 'core.can_view_switch_survey_module_v2',
    CAN_SWITCH_BETWEEN_WORK_UNIT_VIEWS:
      'core.can_switch_between_work_unit_views'
  }
};
